<section
  class="tj-page-header pheader-space"
  [style.background-image]="'url(' + backgroundImage() + ')'"
  appAnimateOnScroll
  (isVisible)="isVisible.set($event)"
>
  
  <div class="flex justify-center">
    <div class="tj-page-header-content text-center">
      <!-- Dynamic Title with Character Animation -->
      <h1 class="tj-page-title font-heading"
        appStaggeredSplitText 
        [text]="title()" 
        [isVisible]="isVisible()"
      >
        <!-- <span 
          *ngFor="let char of titleCharacters; let i = index"
          class="inline-block transition-all duration-700 ease-out"
          [class.opacity-0]="!isVisible()"
          [class.opacity-100]="isVisible()"
          [class.-translate-y-8]="!isVisible()"
          [class.translate-y-0]="isVisible()"
          [style.transition-delay]="(i * 50) + 'ms'"
        >
          {{ char === ' ' ? '&nbsp;' : char }}
        </span> -->
      </h1>

      <!-- Dynamic Breadcrumb -->
      <div
        class="tj-page-link transition-all duration-700 ease-out delay-700"
        [class.opacity-0]="!isVisible()"
        [class.opacity-100]="isVisible()"
        [class.translate-y-10]="!isVisible()"
        [class.translate-y-0]="isVisible()"
      >
        <ng-container *ngFor="let item of breadcrumbs(); let isLast = last; let i = index">
          <!-- Breadcrumb Item -->
          <span
            property="itemListElement"
            typeof="ListItem"
            class="inline-block transition-all duration-300 ease-out"
            [style.transition-delay]="(300 + i * 100) + 'ms'"
            [class.opacity-0]="!isVisible()"
            [class.opacity-100]="isVisible()"
            [class.scale-0]="!isVisible()"
            [class.scale-100]="isVisible()"
          >
            @if(item.route && !item.isActive){
              <a
                class="home hover:text-secondary transition-colors duration-300 cursor-pointer!"
                [routerLink]="item.route"
              >
                <span property="name">{{ item.label }}</span>
              </a>
            }
            @if(item.isActive || !item.route){
              <span
                property="name"
                class="post post-page current-item cursor-pointer"
              >
                {{ item.label }}
              </span>
            }
          </span>
          
          <!-- Separator -->
          <span 
            *ngIf="!isLast" 
            class="inline-block mx-1 transition-all duration-300 ease-out"
            [style.transition-delay]="(350 + i * 100) + 'ms'"
            [class.opacity-0]="!isVisible()"
            [class.opacity-100]="isVisible()"
            [class.rotate-180]="!isVisible()"
            [class.rotate-0]="isVisible()"
          >/</span>
        </ng-container>
      </div>
    </div>
  </div>
  
</section>
